import { render, staticRenderFns } from "./ViewInvoiceItemDetails.vue?vue&type=template&id=4d12c192&"
import script from "./ViewInvoiceItemDetails.vue?vue&type=script&lang=js&"
export * from "./ViewInvoiceItemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports